import React from 'react';
import { Link } from 'react-router-dom';
import SocialShare from './SocialShare';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto py-12 px-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="flex items-center space-x-4">
            <img 
              src="https://media.salesintercept.com/Sales-Intercept-rec-Logo-white-text.png" 
              alt="Sales Intercept Logo" 
              className="h-8"
            />
            <p className="text-gray-400 text-sm">
              © {currentYear} Sales Intercept, Inc. All rights reserved.
            </p>
          </div>
          
          <div className="mt-4 md:mt-0">
            <ul className="flex space-x-6">
              <li><Link to="/real-estate" className="text-gray-400 hover:text-white text-sm">Real Estate</Link></li>
              <li><Link to="#" className="text-gray-400 hover:text-white text-sm contact-us-om">Contact Us</Link></li>
              <li><a href="https://www.linkedin.com/company/sales-intercept/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm">LinkedIn</a></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-white text-sm">Privacy</Link></li>
              <li><Link to="/terms-of-service" className="text-gray-400 hover:text-white text-sm">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;